import { render, staticRenderFns } from "./realname-input-wrap.vue?vue&type=template&id=2ff58975&scoped=true&"
import script from "./realname-input-wrap.vue?vue&type=script&lang=js&"
export * from "./realname-input-wrap.vue?vue&type=script&lang=js&"
import style0 from "./realname-input-wrap.vue?vue&type=style&index=0&id=2ff58975&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ff58975",
  null
  
)

export default component.exports